import { PROTOCOL } from '@src/utils/locale';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
import pageLocalesData from '@src/global-locales/page-locales-data';

const footerLocales = pageLocalesData.common_footer;
const lang = getLanguageByPath();

// 默认协议跳转配置
const links = [
  {
    href: PROTOCOL[getLanguageByPath()].cookie,
    text: footerLocales.cookie_agreement,
    name: 'Cookie协议'
  },
  {
    href: null,
    text: footerLocales.cookie_setting,
    cookieSetting: true,
    name: 'Cookie设定 开关'
  },
  {
    href: PROTOCOL[getLanguageByPath()].privacy,
    text: footerLocales.privacy_policy,
    isFontWeight: lang === 'ko',
    name: '隐私权政策'
  },
  {
    href: PROTOCOL[getLanguageByPath()].service,
    text: footerLocales.terms_of_service,
    name: '使用权协议'
  }
];

// 官方工具
const footerLinks = [
  {
    title: footerLocales.official_tool,
    name: '官方工具',
    items: [
      {
        href: 'https://g.amazingseasun.com/',
        text: footerLocales.game_launcher
      }
    ]
  },
  {
    title: footerLocales.customer_service,
    name: '使用者服务',
    items: [
      {
        href: 'https://account.amazingseasun.com/#/my',
        text: footerLocales.personal_center
      },
      {
        href: 'https://account.amazingseasun.com/#/games',
        text: footerLocales.reCharge_center
      }
    ]
  },
  {
    title: footerLocales.know_us,
    name: '了解我们',
    items: [
      {
        href: 'https://about.seasungames.com/',
        text: footerLocales.about_seasun
      }
    ]
  },
  {
    title: footerLocales.followUs,
    name: '联络我们',
    items: [
      {
        text: footerLocales.support_partner
      },
      {
        text: footerLocales.community
      }
    ]
  },
  {
    title: footerLocales.join_us,
    name: '加入我们',
    items: [
      {
        href: 'https://job.seasungames.com/',
        text: footerLocales.careers
      }
    ]
  }
];

//底部右侧logo链接
const footerRightLogo = [
  {
    img: require('./images/pc_nav_global_logo_white.png'),
    url: 'https://www.seasungames.com/',
    name: 'seasunGames Logo'
  }
];

const Config = {
  /**
   * 配置项，根据语言进行分组
   */
  en: {
    footerLeftLogo: [
      {
        img: require('./images/en/seal.png'),
        url: '//privacy.trustarc.com/privacy-seal/validation?rid=93307ef1-92cf-49a1-8876-511ff47907e4'
      },
      {
        img: require('./images/en/iarc.png'),
        url: ''
      }
    ],
    agreementLinks: links,
    footerLinks: footerLinks,
    footerRightLogo: footerRightLogo
  },
  ja: {
    footerLeftLogo: [
      {
        img: require('./images/ja/seal.png'),
        url: '//privacy.trustarc.com/privacy-seal/validation?rid=08441dad-ade0-4d1e-8db6-0308f3c94a32&lang=ja'
      },
      {
        img: require('./images/ja/iarc.png'),
        url: ''
      }
    ],
    // 日语特殊协议 新增两个链接
    agreementLinks: [
      ...links,
      {
        href: 'https://www.amazingseasun.com/show-1356-180-1.html',
        text: footerLocales.funds_ja
      },
      {
        href: 'https://www.amazingseasun.com/show-1356-179-1.html',
        text: footerLocales.acquisition_ja
      }
    ],
    footerLinks: footerLinks,
    footerRightLogo: footerRightLogo
  },
  ko: {
    footerLeftLogo: [
      {
        img: require('./images/ko/seal.png'),
        url: '//privacy.trustarc.com/privacy-seal/validation?rid=cd4c49da-fab8-4a91-bfaa-f7f2b89cf362&lang=ko'
      },
      {
        img: require('./images/ko/iarc.png'),
        url: ''
      }
    ],
    agreementLinks: links,
    footerLinks: footerLinks,
    footerRightLogo: footerRightLogo
  },
  'zh-Hant': {
    footerLeftLogo: [
      {
        img: require('./images/zh-Hant/seal.png'),
        url: ''
      }
    ],
    agreementLinks: links,
    footerLinks: footerLinks,
    footerRightLogo: [
      ...footerRightLogo,
      {
        img: require('./images/global_logo.png'),
        url: ''
      }
    ]
  },
  es: {
    footerLeftLogo: [
      {
        img: require('./images/es/seal.png'),
        url: '//privacy.trustarc.com/privacy-seal/validation?rid=d5bdbf52-2dd2-44d4-9f67-f997267a30a9&lang=es'
      },
      {
        img: require('./images/es/iarc.png'),
        url: ''
      }
    ],
    agreementLinks: links,
    footerLinks: footerLinks,
    footerRightLogo: footerRightLogo
  },
  pt: {
    footerLeftLogo: [
      {
        img: require('./images/pt/seal.png'),
        url: '//privacy.trustarc.com/privacy-seal/validation?rid=09956988-357a-458b-a77c-ccff6d4c0410&lang=pt-br'
      },
      {
        img: require('./images/pt/iarc.png'),
        url: ''
      }
    ],
    agreementLinks: links,
    footerLinks: footerLinks,
    footerRightLogo: footerRightLogo
  },
  de: {
    footerLeftLogo: [
      {
        img: require('./images/de/seal.png'),
        url: '//privacy.trustarc.com/privacy-seal/validation?rid=fc0812bb-a6e1-409d-913c-fe54525e522b&lang=de'
      },
      {
        img: require('./images/de/iarc.png'),
        url: ''
      }
    ],
    agreementLinks: links,
    footerLinks: footerLinks,
    footerRightLogo: footerRightLogo
  },
  fr: {
    footerLeftLogo: [
      {
        img: require('./images/fr/seal.png'),
        url: '//privacy.trustarc.com/privacy-seal/validation?rid=0cb01fac-c229-464c-b3a2-4c64273cd23a&lang=fr'
      },
      {
        img: require('./images/fr/iarc.png'),
        url: ''
      }
    ],
    agreementLinks: links,
    footerLinks: footerLinks,
    footerRightLogo: footerRightLogo
  },
  ru: {
    footerLeftLogo: [
      {
        img: require('./images/ru/seal.png'),
        url: '//privacy.trustarc.com/privacy-seal/validation?rid=7f13aee5-fbad-4177-a0be-9835a9de1f69&lang=ru'
      },
      {
        img: require('./images/ru/iarc.png'),
        url: ''
      }
    ],
    agreementLinks: links,
    footerLinks: footerLinks,
    footerRightLogo: footerRightLogo
  },
  th: {
    footerLeftLogo: [
      {
        img: '',
        url: ''
      }
    ],
    agreementLinks: links,
    footerLinks: footerLinks,
    footerRightLogo: footerRightLogo
  }
};

export default Config;
